import styled from 'styled-components';

const StyledMenu = styled.div`
    margin-top: 10px;
    grid-area: menu;
    .container{
        padding-right: 0;
        padding-left: 0;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 1rem !important;
    }

    .header-asistente h1{
        font-size: 1.7rem;
    }
    .text-primary {
        color: #e81e2b !important;
    }
    .text-neutral-alfa-25 {
        color: rgba(31,30,30,.25) !important;
    }
    .header-asistente p{
        font-size: 1rem;
        padding-bottom: 24px;
        color: #383838;
        font-weight: 400;
    }
    .header-asistente {
        margin-bottom: 16px;
    }
    .mb-4, .my-4{
        margin-bottom: 0;
    }

    @media (max-width: 768px){
        .header-asistente h1{
            font-size: 1.6rem;
        }
        .header-asistente p{
            font-size: 1rem;
            padding-bottom: 24px;
            color: #383838;
            font-weight: 400;
        }
        ._33aQi ._1SUVn{
            font-size: 0.8rem;
        }
    }

    @media (max-width:425px){
        .header-asistente h1{
            font-size: 1.4rem;
        }
        .header-asistente p{
            font-size: 1rem;
            padding-bottom: 24px;
            color: #383838;
            font-weight: 400;
        }

        .header-asistente p {
            display: none;
        }
    }

    @media (max-width: 375px){
        .header-asistente h1{
            font-size: 1.3rem;
        }
        .header-asistente p{
            font-size: 0.875rem;
            padding-bottom: 24px;
            color: #383838;
            font-weight: 400;
        }
        .header-asistente p {
            display: none;
        }
    }

    @media(max-width: 320px){
        .text-primary, .text-neutral-alfa-35 {
         font-size: 0.8rem
        }
        .header-asistente h1{
         font-size: 1.1rem;
        }
        .header-asistente p{
         font-size: 0.875rem;
         padding-bottom: 24px;
         color: #383838;
         font-weight: 400;
        }
        .header-asistente p {
            display: none;
        }
    } 
`;

export default StyledMenu;
